import { LiquidSpotIcon } from './LiquidSpotIcon';

/**
 * author: Michael Irigoyen
 * id BAB8D475-0C50-46EB-9B05-8101442C4F33
 * name liquid-spot
 * version: 6.1.95
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/liquid-spot.svg
 * tags
 * - Automotive 
 * - Medical / Hospital 
 */
export const SpillIcon = LiquidSpotIcon;
export default SpillIcon